import { render, staticRenderFns } from "./ListThumbnail.vue?vue&type=template&id=4589d195"
import script from "./ListThumbnail.vue?vue&type=script&lang=js"
export * from "./ListThumbnail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports